import { NgModule } from "@angular/core";
import { Routes, RouterModule } from "@angular/router";
import { AdministrarParametrosTotemComponent } from "./administrar-parametros-totem-component";

const routes: Routes = [
  { path: "", component: AdministrarParametrosTotemComponent },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class AdministrarParametrosTotemComponentRoutingModule {}
